module.exports = __webpack_public_path__ + "img/car-13.2c3b4ebb.jpg";